const STORAGE = {
    LOCAL_STORAGE: 'localStorage',
    SESSION_STORAGE: 'sessionStorage'
};

function storage(which = 'localStorage', namespace, data) {
    if (data === false) {
        return window[which].removeItem(namespace);
    }
    if (data) {
        return window[which].setItem(namespace, JSON.stringify(data));
    }

    let store = window[which].getItem(namespace);

    return (store && JSON.parse(store)) || false;
}

function clearStorage(which = 'localStorage') {
    window[which].clear();
}

module.exports = {
    clearLocalStorage: clearStorage.bind(undefined, STORAGE.LOCAL_STORAGE),
    clearSessionStorage: clearStorage.bind(undefined, STORAGE.SESSION_STORAGE),
    localStorage: storage.bind(undefined, STORAGE.LOCAL_STORAGE),
    storage: storage.bind(undefined, STORAGE.LOCAL_STORAGE),
    sessionStorage: storage.bind(undefined, STORAGE.SESSION_STORAGE)
};